module.exports = __webpack_public_path__ + "static/img/Record_vitals.ebe39b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Record_vitals.jpg
// module id = z2wa
// module chunks = 7